import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable @typescript-eslint/unbound-method */
import { ChevronDown } from '@flowio/react-icons';
import { Menu } from '@flowio/react-menu';
import { Popover } from '@flowio/react-popover';
import { TextInput } from '@flowio/react-text-input';
import React from 'react';
import caseInsensitiveFilter from '../utilities/caseInsensitiveFilter';
var defaultProps = {
  autoWidth: false,
  closeOnClickAway: true,
  closeOnEscape: true,
  closeOnInvisible: false,
  closeOnSelection: true,
  closeOnResize: false,
  closeOnScroll: false,
  constraint: 'flipfit flipfit',
  defaultOpen: false,
  disabled: false,
  fluid: false,
  hintText: 'Select...',
  intent: 'neutral',
  lockScrolling: true,
  offset: '0px 2px',
  openOnClick: true,
  openOnHover: false,
  openOnFocus: true,
  openOnSpace: false,
  options: [],
  position: 'bottom left',
  size: 'medium',
  filterOption: caseInsensitiveFilter,
  searchable: false
};

function getInitialState(props) {
  return {
    open: props.open != null ? props.open : props.defaultOpen,
    value: props.value != null ? props.value : props.defaultValue,
    textFieldSearchValue: undefined
  };
}

function getDerivedStateFromProps(props, state) {
  return {
    open: props.open != null ? props.open : state.open,
    value: props.value != null ? props.value : state.value
  };
}

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);
    _this.state = getInitialState(_this.props);
    _this.handlePopoverClose = _this.handlePopoverClose.bind(_assertThisInitialized(_this));
    _this.handlePopoverOpen = _this.handlePopoverOpen.bind(_assertThisInitialized(_this));
    _this.handleMenuItemSelection = _this.handleMenuItemSelection.bind(_assertThisInitialized(_this));
    _this.handleMenuMouseDown = _this.handleMenuMouseDown.bind(_assertThisInitialized(_this));
    _this.handleTextInputValueChange = _this.handleTextInputValueChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "handlePopoverOpen",
    value: function handlePopoverOpen() {
      this.open();
    }
  }, {
    key: "handlePopoverClose",
    value: function handlePopoverClose() {
      this.close();
    }
  }, {
    key: "handleMenuItemSelection",
    value: function handleMenuItemSelection(index, value) {
      var closeOnSelection = this.props.closeOnSelection;
      var option = this.getOptionAtIndex(index);

      if (value != null) {
        this.changeValue(value);
      } else if (option != null) {
        this.changeValue(option.value);
      }

      if (closeOnSelection) {
        this.close();
      }
    }
  }, {
    key: "handleMenuMouseDown",
    value: function handleMenuMouseDown(event) {
      var openOnFocus = this.props.openOnFocus;
      /*
        By default, a popover that opens on focus will close itself when focus
        is lost to an element that isn't within the popover, including its trigger
        element. However, menus don't receive focus on interaction and the popover
        will close. To prevent this behavior we stop the mouse event.
         We don't allow focus on the menu element for usability reasons. That is,
        we prefer for the next tab to shift focus to the next control element
        in a form instead of the menu.
      */

      if (openOnFocus) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "handleTextInputValueChange",
    value: function handleTextInputValueChange(value) {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.props.searchable) {
        this.setState({
          textFieldSearchValue: value,
          open: true
        });
      }

      var option = this.getOptionByValue(value);

      if (option != null) {
        this.changeValue(option.value);
      }
    }
  }, {
    key: "getOptionByValue",
    value: function getOptionByValue(value) {
      var options = this.props.options;
      return options.find(function (option) {
        return option.value === value;
      });
    }
  }, {
    key: "getOptionAtIndex",
    value: function getOptionAtIndex(index) {
      var options = this.props.options;
      return options[index];
    }
  }, {
    key: "getSelectedOption",
    value: function getSelectedOption() {
      var options = this.props.options;
      var value = this.state.value;
      return options.find(function (option) {
        return option.value === value;
      });
    }
  }, {
    key: "isOpenControlled",
    value: function isOpenControlled() {
      var open = this.props.open;
      return open != null;
    }
  }, {
    key: "isValueControlled",
    value: function isValueControlled() {
      var value = this.props.value;
      return value != null;
    }
  }, {
    key: "open",
    value: function open() {
      var onOpen = this.props.onOpen;

      if (!this.isOpenControlled()) {
        this.setState({
          open: true
        });
      }

      if (typeof onOpen === 'function') {
        onOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      var onClose = this.props.onClose;

      if (!this.isOpenControlled()) {
        this.setState({
          open: false
        });
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    }
  }, {
    key: "changeValue",
    value: function changeValue(value) {
      var onValueChange = this.props.onValueChange; // setting undefined to let the text-input field take the selected option value.

      this.setState({
        textFieldSearchValue: undefined
      });

      if (!this.isValueControlled()) {
        this.setState({
          value: value
        });
      }

      if (typeof onValueChange === 'function') {
        onValueChange(value);
      }
    }
  }, {
    key: "renderControl",
    value: function renderControl() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          fluid = _this$props.fluid,
          hintText = _this$props.hintText,
          intent = _this$props.intent,
          size = _this$props.size,
          textInputProps = _this$props.textInputProps,
          searchable = _this$props.searchable;
      var textFieldSearchValue = this.state.textFieldSearchValue;
      var selectedOption = this.getSelectedOption(); // Take value as textFieldSearchValue if truthy value.
      // Default to empty string to suppress warning about component
      // changing from uncontrolled to controlled value.

      var value = textFieldSearchValue || (selectedOption != null ? selectedOption.content : textFieldSearchValue);
      return /*#__PURE__*/React.createElement(TextInput, _extends({}, textInputProps, {
        className: className,
        disabled: disabled,
        fluid: fluid,
        hintText: hintText,
        intent: intent,
        onValueChange: this.handleTextInputValueChange,
        readOnly: !searchable,
        rightIcon: ChevronDown,
        size: size,
        value: value
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this$props2 = this.props,
          menuProps = _this$props2.menuProps,
          options = _this$props2.options,
          searchable = _this$props2.searchable,
          filterOption = _this$props2.filterOption;
      var _this$state = this.state,
          value = _this$state.value,
          textFieldSearchValue = _this$state.textFieldSearchValue;
      var filteredOptions = options;

      if (textFieldSearchValue && searchable) {
        filteredOptions = options.filter(function (option) {
          return filterOption(option, textFieldSearchValue);
        });
      }

      return /*#__PURE__*/React.createElement(Menu, _extends({}, menuProps, {
        items: filteredOptions,
        onItemSelection: this.handleMenuItemSelection,
        onMouseDown: this.handleMenuMouseDown,
        value: value
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          closeOnClickAway = _this$props3.closeOnClickAway,
          closeOnEscape = _this$props3.closeOnEscape,
          closeOnInvisible = _this$props3.closeOnInvisible,
          closeOnResize = _this$props3.closeOnResize,
          closeOnScroll = _this$props3.closeOnScroll,
          constraint = _this$props3.constraint,
          disabled = _this$props3.disabled,
          lockScrolling = _this$props3.lockScrolling,
          offset = _this$props3.offset,
          openOnClick = _this$props3.openOnClick,
          openOnFocus = _this$props3.openOnFocus,
          openOnHover = _this$props3.openOnHover,
          openOnSpace = _this$props3.openOnSpace,
          popoverProps = _this$props3.popoverProps,
          position = _this$props3.position;
      var open = this.state.open;
      return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverProps, {
        closeOnClickAway: closeOnClickAway,
        closeOnEscape: closeOnEscape,
        closeOnInvisible: closeOnInvisible,
        closeOnResize: closeOnResize,
        closeOnScroll: closeOnScroll,
        constraint: constraint,
        disabled: disabled,
        lockScrolling: lockScrolling,
        offset: offset,
        onClose: this.handlePopoverClose,
        onOpen: this.handlePopoverOpen,
        open: open,
        openOnClick: openOnClick,
        openOnFocus: openOnFocus,
        openOnHover: openOnHover,
        openOnSpace: openOnSpace,
        position: position,
        trigger: this.renderControl()
      }), this.renderMenu());
    }
  }]);

  return Select;
}(React.Component);

_defineProperty(Select, "displayName", 'Select');

_defineProperty(Select, "defaultProps", defaultProps);

_defineProperty(Select, "getDerivedStateFromProps", getDerivedStateFromProps);

export default Select;